import {
  Box,
  Card,
  Checkbox,
  Flex,
  Heading,
  Label,
  Layout,
  ListItem,
  Text,
} from '@modusign/design-system';
import { useVerification } from '@modusign/react-signing';

import noop from '@libs/noop';

import RecommendedBadge from '@app/features/contractLink/contractLinkCreate/components/RecommendedBadge';

interface ContractLinkCreateSignerAuthCardProps {
  signerId: string;
}

function ContractLinkCreateSignerAuthCard({ signerId }: ContractLinkCreateSignerAuthCardProps) {
  const { addMethod, removeMethod, verification } = useVerification(signerId);
  const hasMobileVerification = verification?.methods.some(
    (method) => method.type === 'MOBILE_IDENTIFICATION'
  );

  function handleToggleMobileAuthRequired() {
    if (hasMobileVerification) {
      removeMethod('MOBILE_IDENTIFICATION');
    } else {
      addMethod({
        type: 'MOBILE_IDENTIFICATION',
        displayPhoneNumber: null,
        displayName: null,
        hint: null,
        passValue: '',
      });
    }
  }

  return (
    <Layout
      alignItems="center"
      bg="#d2d2d2"
      borderRadius={4}
      justifyContent="center"
      mb={4}
      pt={4}
      px={4}
      width="100%"
    >
      <Card flex={1} mb={4} p={0} pb={8} pt={7} px={7}>
        <Heading fontSize="md" mb={6}>
          서명자 인증
        </Heading>
        <Box as="ul">
          <ListItem>
            <Flex justifyContent="space-between" width="100%">
              <Box>
                <Label htmlFor="linkTitle" mr={3}>
                  휴대폰 본인 인증
                </Label>
                <RecommendedBadge />
              </Box>

              <Checkbox
                checked={hasMobileVerification}
                onChange={noop}
                onClick={handleToggleMobileAuthRequired}
              />
            </Flex>
          </ListItem>
          <Text as="p" color="textNeutralLight" pl="11px">
            서명자는 휴대폰 본인 인증 후, 서명할 수 있습니다.
            <br />
            본인 확인 및 도용 피해를 예방하기 위해 설정을 권장합니다.
          </Text>
        </Box>
      </Card>
    </Layout>
  );
}

export default ContractLinkCreateSignerAuthCard;
